import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { CustomTab } from '../shared/tab/tab';
import { Header } from '../shared/header/header';
import { Tabs } from '../../config/cuTabConfig';
import { CreatedProducts } from './createdProducts';
import { RawMaterial } from './rawMaterial';
import { ProductType } from './productType';
import { Department } from './department';
import { CertificateAdditionalDocuments } from './certificateAdditionalDocuments';
import { useAsyncOperation } from '../../utils/use-async-operation';
import { CUMasterType } from '../../types/cu.types';
import { getCUMaster } from '../../services/cu-service';
import { Loader } from '../shared/loader/loader';
import { CustomAlert } from '../shared/alert/alert';

export const testid = 'brand-certification';

export const ControlUnion = (): ReactElement => {
	const classes = useStyles();
	const isSupplier = localStorage.getItem('isSupplierAccount') === 'true';
	const visibleForSupplier = Tabs.find((tab) => tab.value === 'Certificate & additional documents');
	const [activeTab, setActiveTab] = useState<number>(isSupplier ? visibleForSupplier?.key ?? 0 : 0);
	const [errorAlertOpen, setErrorAlertOpen] = useState(false);
	const initialLoadTriggered = useRef(false);

	const [getMaster, masterBusy, masterData, masterError] = useAsyncOperation<CUMasterType>(getCUMaster);

	useEffect(() => {
		if (initialLoadTriggered.current) return;
		initialLoadTriggered.current = true;
		getMaster();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (masterError) setErrorAlertOpen(true);
	}, [masterError]);

	return (
		<>
			<Header title="H&M Group Brand Scope Certificate" />
			<>
				<div className={classes.topPadding}>
					<CustomTab data={(isSupplier ? Tabs.filter((tab) => tab.key === 4) : Tabs)} value={activeTab} onChangeCallback={setActiveTab} />
				</div>
				<Loader key={`${testid}-loader`} open={masterBusy} message="Loading..." />
				{errorAlertOpen && (
					<CustomAlert
						open={errorAlertOpen}
						message="Something went wrong while retrieving master data!"
						severity="error"
						timeout={5000}
						isFade={false}
						onCloseCallback={() => {
							setErrorAlertOpen(false);
						}}
					/>
				)}

				{!isSupplier && activeTab === 0 && masterData && <CreatedProducts master={masterData} />}
				{!isSupplier && activeTab === 1 && masterData && <RawMaterial master={masterData} />}
				{!isSupplier && activeTab === 2 && masterData && <ProductType master={masterData} />}
				{!isSupplier && activeTab === 3 && masterData && <Department master={masterData} />}
				{activeTab === 4 && masterData && <CertificateAdditionalDocuments />}
			</>
		</>
	);
};

const useStyles = makeStyles(() => ({
	topPadding: {
		paddingTop: '15px',
	},
}));
